var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4688 12.5625C15.5312 12.5 15.625 12.4688 15.6875 12.4062C16.375 11.6875 16.7812 10.75 16.75 9.71875C16.75 7.6875 15.0625 6 13 6H6.75C6.3125 6 6 6.34375 6 6.75C6 7.1875 6.3125 7.5 6.75 7.5H7.5V18.5H6.75C6.3125 18.5 6 18.8438 6 19.25C6 19.6875 6.3125 20 6.75 20H13.5C15.6875 20 17.5 18.2188 17.5 16C17.5 14.5312 16.6562 13.25 15.4688 12.5625ZM13 7.5C14.25 7.5 15.25 8.5 15.25 9.75C15.2812 10.3438 15.0312 10.9062 14.625 11.3438C14.1875 11.7812 13.625 12 13 12H9V7.5H13ZM13.5 18.5H9V13.5H13.5C14.875 13.5 16 14.625 16 16.0312C16 17.4062 14.875 18.5 13.5 18.5Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/Bold.c3c782ab88404f97a3110c7c9c0aabb4.svg";
export { ForwardRef as ReactComponent };